import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { SET_ENTRY_CHECKLIST_ITEM_PACKED } from '../entryPhotos/operations';
import { getPublicErrorMessage } from '../../utils/errors';
import { moduleCommonStrings } from '../../content/hobbyModules';
import './entryChecklistProgress.css';

/** Shows a checklist on details and persists one packed state at a time. */
export default function EntryChecklistProgress({ hobbyId, entryId, items, canEdit = false, onChanged }) {
  const [savingId, setSavingId] = useState(null);
  const [error, setError] = useState('');
  const [overrides, setOverrides] = useState({});
  const [setPacked] = useMutation(SET_ENTRY_CHECKLIST_ITEM_PACKED);

  const toggle = async (item) => {
    if (!canEdit || !item.id || savingId) return;
    const nextPacked = !(Object.prototype.hasOwnProperty.call(overrides, item.id) ? overrides[item.id] : item.packed);
    setOverrides((current) => ({ ...current, [item.id]: nextPacked }));
    setSavingId(item.id);
    setError('');
    try {
      await setPacked({ variables: { hobbyId, entryId, itemId: item.id, packed: nextPacked } });
      try {
        await onChanged?.();
        setOverrides((current) => { const next = { ...current }; delete next[item.id]; return next; });
      } catch {
        setError(moduleCommonStrings.checklistRefreshFailed);
      }
    } catch (cause) {
      setOverrides((current) => { const next = { ...current }; delete next[item.id]; return next; });
      setError(getPublicErrorMessage(cause));
    } finally {
      setSavingId(null);
    }
  };

  return <div className="detail-checklist-list">
    {items.map((item, index) => <label className="detail-checklist-progress-row" key={item.id || `${item.title}-${index}`}>
      <input type="checkbox" checked={Object.prototype.hasOwnProperty.call(overrides, item.id) ? overrides[item.id] : Boolean(item.packed)} disabled={!canEdit || !item.id || Boolean(savingId)} onChange={() => toggle(item)} aria-label={item.title} />
      <span>{item.title}</span>
      {item.category && <small>{item.category}</small>}
    </label>)}
    {error && <p className="form-error" role="alert">{error}</p>}
  </div>;
}
